export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type Sort = {
  field: string;
  order: SortOrder;
};
